const Footer = () => <div id="navigationFooter" />;

export default Footer;
